import * as React from 'react';
const LegacySelectContext = React.createContext(null);
export default LegacySelectContext;
